export default function Reason() {
  return (
    <section
      id="reason"
      className="relative bg-kiln overflow-hidden"
      style={{ padding: '8rem 4rem' }}
    >
      {/* Subtle background texture */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/3d6b7419f201d1ff5d9a48106ee94f25.webp"
          alt="奄美の海景色"
          className="w-full h-full object-cover [object-position:70%_50%] md:object-center"
        />
        <div className="absolute inset-0 bg-kiln/85" />
      </div>

      <div className="relative max-w-2xl mx-auto text-center">
        {/* Label */}
        <span className="inline-block bg-white/10 text-white/80 text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-8">
          / REASON TO RETURN
        </span>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-white mb-14 leading-tight">
          「また来たい」の理由がある。
        </h2>

        {/* Body text */}
        <div
          className="text-white/90 font-rounded text-base md:text-lg text-left space-y-6 max-w-xl mx-auto"
          style={{ lineHeight: '2.1' }}
        >
          <p>
            おいしいピザなら、都会にもある。<br />
            焼きたてなら、近所のお店でも食べられる。
          </p>
          <p>
            じゃあ、なんでまた奄美まで来たくなるんだろう。<br />
            たぶんそれは、ピザの味だけじゃないんです。
          </p>
          <p>
            焼き上がりをぼーっと待つ時間。<br />
            「このたんかん、うちの畑のだよ」って話しながら食べる一枚。<br />
            帰り道にふと目に入る、宇検村の海の色。<br />
            <br />
            ぜんぶひっくるめて「ふぅばてぇ」だったんだ、って
          </p>
        </div>

        {/* Highlighted closing line */}
        <div className="mt-8 max-w-xl mx-auto text-left">
          <p
            className="text-white font-rounded font-black text-xl md:text-2xl lg:text-3xl"
            style={{ lineHeight: '1.8' }}
          >
            帰ってから気づく方が多いみたいです。
          </p>
        </div>

        {/* Decorative divider */}
        <div className="mt-14 flex items-center justify-center gap-4">
          <div className="w-16 h-px bg-white/20" />
          <div className="w-2 h-2 rounded-full bg-white/30" />
          <div className="w-16 h-px bg-white/20" />
        </div>
      </div>
    </section>
  );
}
